<ng-container *transloco="let t">
  <h2 tuiTitle="m">{{ title }}</h2>
  @let pdfPreview = pdfPreview$ | async;

  <div class="flex min-h-0 flex-1 flex-col gap-6 sm:grid sm:grid-cols-[1fr_3fr]">
    <div class="flex flex-col justify-between gap-6 sm:min-h-0 sm:overflow-auto">
      <form class="flex flex-col gap-2" [formGroup]="form">
        <h3>{{ t('Sélectionnez un modèle de rapport') }}</h3>
        <pxc-report-template-picker formControlName="templateId" [templates]="templates$ | async" />
      </form>

      <div class="flex flex-col gap-2">
        <button
          appearance="primary"
          tuiButton
          type="button"
          [disabled]="!pdfPreview.isSuccess"
          (click)="download(pdfPreview.data.content)">
          {{ t('Télécharger') }}
        </button>

        <button appearance="outline" tuiButton type="button" (click)="close()">
          {{ t('Annuler') }}
        </button>
      </div>
    </div>

    <div
      class="flex h-80 w-full items-center justify-center rounded-lg text-center sm:h-full sm:bg-background-tertiary">
      @if (pdfPreview.isLoading) {
        <pxc-spinner [message]="t('Chargement de l\'aperçu en cours ...')" />
      } @else if (pdfPreview.isSuccess) {
        <pxc-pdf-previewer [source]="pdfPreview.data.preview" />
      } @else if (pdfPreview.hasError) {
        <tui-block-status data-testid="status-fail" size="m">
          <h4>{{ t('Échec') }}</h4>
          {{ t('Une erreur est survenue lors de la génération du rapport') }}
        </tui-block-status>
      } @else {
        <span class="text-text-tertiary">
          {{ t('Sélectionnez un modèle de rapport pour afficher un aperçu.') }}
        </span>
      }
    </div>
  </div>
</ng-container>
